import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-chckbox',
  templateUrl: './chckbox.component.html',
  styleUrls: ['./chckbox.component.scss']
})
export class ChckboxComponent extends BaseComponent implements OnInit {

  @Input() checkboxId: string;

  @Input() isSelected: boolean;

  @Input() text: string;

  @Input() checkBoxData: any;

  @Input() data: any;

  @Output() checkBoxClicked: EventEmitter<object> = new EventEmitter();

  isEnable: boolean;

  constructor(ele: ElementRef) {
    super(ele);
    this.isSelected = false;
  }

  ngOnInit() {
    this.isEnable = true;
  }

  onClick() {
    if (!this.isEnable) {
      return;
    }
    this.isSelected = !this.isSelected;

    if (this.isSelected) {
      this.checkBoxClicked.emit({ 'checkboxState': CheckboxState.CHECKED, 'data': this.data });
    } else {
      this.checkBoxClicked.emit({ 'checkboxState': CheckboxState.UNCHECKED, 'data': this.data, 'self': this });
    }
  }

}

export enum CheckboxState {
  UNCHECKED = 0,
  CHECKED = 1
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/chckbox/chckbox.component.ts